<template>
  <div>
    <el-drawer
      v-if="visible"
      show-close
      visible
      append-to-body
      :size="500"
      top="5vh"
      title="详情查看"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :before-close="() => close()"
    >
      <div class="drawer-main" v-loading="loading">
        <iframe
          height="100%"
          class="detail-iframe"
          width="100%"
          :src="form.payBillUrl"
          ref="iframe"
          frameborder="0"
          @load="iFrameOnLoad"
        >
        </iframe>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    finPaymentNoInvoice: { type: String, default: '' },
  },
  data() {
    return {
      form: {},
      loading: true,
    }
  },
  watch: {
    finPaymentNoInvoice: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    iFrameOnLoad() {
      this.loading = false
    },
    getData() {
      if (this.finPaymentNoInvoice) {
        this.$api
          .finPaymentNoInvoiceDetailApi({
            finPaymentNoInvoice: this.finPaymentNoInvoice,
          })
          .then((res) => {
            this.form = res.body
          })
      }
    },
    close() {
      this.form = {}
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style scoped>
.drawer-main {
  background-color: #eef3f8;
  height: 100%;
  width: 100%;
}
.detail-iframe {
  width: 100%;
}
.detail-iframe body {
  background-color: #f1f1f1 !important;
}
::v-deep .el-drawer__body {
  overflow: hidden !important;
}
</style>
